import { redirect } from 'react-router-dom';

import { getMe } from 'src/services/getMe';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';
import { buildNoAccessPath } from '../constants';

export const requireAuthLoader = async ({ request }) => {
	try {
		const me = await getMe({ fetchPolicy: 'network-only' });

		if (!me) {
			throw redirect(buildNoAccessPath(request));
		}

		return me;
	} catch (error) {
		if (typeof Response !== 'undefined' && error instanceof Response) {
			throw error;
		}

		if (isUnauthorizedError(error)) {
			throw redirect(buildNoAccessPath(request));
		}

		throw error;
	}
};
